import React from "react";
import Axios from "axios";
import { init } from "@src/utils/logClient";
import window from "global/window";
import { APIDomain } from "@src/utils/APIDomain";

type MobileData = {
  user?: any;
};
type MobileDataContextProps = { data: MobileData; set: (MobileData) => void };

const defaultContextValue = {
  data: { user: undefined },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set: () => {},
};

const MobileDataContext = React.createContext<MobileDataContextProps>(defaultContextValue);

class MobileDataContextProvider extends React.Component<Record<string, unknown>, MobileDataContextProps> {
  constructor(props) {
    super(props);

    this.setData = this.setData.bind(this);
    this.state = {
      ...defaultContextValue,
      set: this.setData,
    };
  }

  componentDidMount() {
    if (process.env.GATSBY_ENV === "development") {
      init({
        site: "mobile-web",
        env: "dev",
        customEndpoint: "/logs",
      });
    } else {
      init({
        site: "mobile-web",
        env: "prod",
        customEndpoint: "/logs",
        buildNumber: `${process.env.GATSBY_BUILD_NUMBER}-${process.env.GATSBY_GIT_COMMIT}`,
      });
    }

    this.getSession();
  }

  getSession() {
    const SESSION = `${APIDomain}/api/session`;
    Axios.get(SESSION, { withCredentials: true })
      .then((response) => {
        const data: MobileData = { user: response.data };
        this.setData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setData(newData) {
    this.setState((state: MobileDataContextProps) => ({
      data: {
        ...state.data,
        ...newData,
      },
    }));
  }

  render() {
    return <MobileDataContext.Provider value={this.state}>{this.props.children}</MobileDataContext.Provider>;
  }
}

export { MobileDataContext, MobileDataContextProvider };
